const initialState = {
  darkTheme: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DARK_THEME':
      return {
        ...state,
        darkTheme: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;